import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { YearApi } from '../+api';
import { YearInterface } from '../+models';
import { YearServiceInterface } from './year.service.interface';

@Injectable({
  providedIn: 'root',
})
export class YearService implements YearServiceInterface {
  private yearApi = inject(YearApi);

  constructor() {}

  getAll(): Observable<YearInterface[]> {
    return this.yearApi.find();
  }

  getYears$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: YearInterface[]; count: number }> {
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters || {}),
        columns: JSON.stringify(columns || null),
        sorting: JSON.stringify(sorting || {}),
        pagination: JSON.stringify(pagination || {}),
      },
    });
    return this.yearApi.getYears(params);
  }

  createYear(year: YearInterface): Observable<YearInterface> {
    return this.yearApi.createYear(year);
  }

  updateYear(year: YearInterface): Observable<YearInterface> {
    const params = new HttpParams({
      fromObject: {
        id: year.id?.toString(),
      },
    });
    return this.yearApi.updateYear(params, year);
  }

  deleteYear(year: YearInterface): Observable<boolean> {
    return this.yearApi.deleteById(year.id);
  }
}
